import type { TrainingLocation } from '@/api/types/enrollment'
import {
  ENROLLMENT_COMMON_MESSAGES,
  ENROLLMENT_VALIDATION_MESSAGES
} from '../../constants/enrollmentContent'
import {
  getStoredDraftLocationExternalId,
  getStoredDraftZipCode,
  getStoredEnrollmentDraftRecord
} from '../../utils/enrollmentStorageSelectors'
import {
  getEnrollmentDraftEmail,
  getEnrollmentDraftFirstName,
  getEnrollmentDraftLastName,
  getEnrollmentDraftPhoneNumber
} from '../../utils/enrollmentDraftSelectors'
import type { CallRequestErrors, CallRequestForm } from './types'

export function getInitialCallRequestForm(): CallRequestForm {
  const stored = getStoredEnrollmentDraftRecord()

  return {
    trainingLocationExternalId: getStoredDraftLocationExternalId(stored),
    firstName: getEnrollmentDraftFirstName(stored.firstName),
    lastName: getEnrollmentDraftLastName(stored.lastName),
    email: getEnrollmentDraftEmail(stored.email),
    phone: getEnrollmentDraftPhoneNumber(stored.phoneNumber || stored.phone),
    preferredCallTime: '',
    notes: ''
  }
}

export function getCallRequestZipFromStorage() {
  return getStoredDraftZipCode()
}

export function validateCallRequestForm(form: CallRequestForm) {
  const errors: CallRequestErrors = {}

  if (!form.firstName.trim()) errors.firstName = ENROLLMENT_VALIDATION_MESSAGES.firstNameRequired
  if (!form.lastName.trim()) errors.lastName = ENROLLMENT_VALIDATION_MESSAGES.lastNameRequired
  if (!form.email.trim()) errors.email = ENROLLMENT_VALIDATION_MESSAGES.emailShortRequired
  if (!form.phone.trim()) errors.phone = ENROLLMENT_VALIDATION_MESSAGES.phoneRequired

  return errors
}

export function toCallRequestLocationOption(location: TrainingLocation) {
  return {
    label: [location.name, location.city, location.state].filter(Boolean).join(' - '),
    value: String(location.externalId || location.id)
  }
}

export function getCallRequestErrorMessage(error: unknown) {
  return error instanceof Error ? error.message : ENROLLMENT_COMMON_MESSAGES.callRequestFailed
}
